import livingR from './images/livingRoom/living_r.jpg';
import livingL from './images/livingRoom/living_l.jpg';
import livingU from './images/livingRoom/living_u.jpg';
import livingD from './images/livingRoom/living_d.jpg';
import livingB from './images/livingRoom/living_b.jpg';
import livingF from './images/livingRoom/living_f.jpg';

import balconyR from './images/balcony/balcony_r.jpg';
import balconyL from './images/balcony/balcony_l.jpg';
import balconyU from './images/balcony/balcony_u.jpg';
import balconyD from './images/balcony/balcony_d.jpg';
import balconyB from './images/balcony/balcony_b.jpg';
import balconyF from './images/balcony/balcony_f.jpg';

import kitchenR from './images/kitchen/kitchen_r.jpg';
import kitchenL from './images/kitchen/kitchen_l.jpg';
import kitchenU from './images/kitchen/kitchen_u.jpg';
import kitchenD from './images/kitchen/kitchen_d.jpg';
import kitchenB from './images/kitchen/kitchen_b.jpg';
import kitchenF from './images/kitchen/kitchen_f.jpg';

interface Images {
    livingRoomList: string[];
    balconyList: string[];
    kitchenList: string[];
}
export const images: Images = {
    livingRoomList: [livingR, livingL, livingU, livingD, livingF, livingB],
    balconyList: [balconyR, balconyL, balconyU, balconyD, balconyF, balconyB],
    kitchenList: [kitchenR, kitchenL, kitchenU, kitchenD, kitchenF, kitchenB],
}
